/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ApplicationDocument
 */
export interface ApplicationDocument {
  /**
   *
   * @type {string}
   * @memberof ApplicationDocument
   */
  id?: string
  /**
   * Наименование документа для отображения на фронте
   * @type {string}
   * @memberof ApplicationDocument
   */
  docName?: string
  /**
   * Есть документы "заглушки" на которые нет ссылки
   * @type {boolean}
   * @memberof ApplicationDocument
   */
  linkRequired?: boolean
  /**
   * Указывает, должен ли документ иметь визуальную отметку с информацией, об статусе обработки документа
   * @type {boolean}
   * @memberof ApplicationDocument
   */
  requiredAnswer?: boolean
  /**
   * Указывает, был ли ответ на документ. Всегда false для документов, у которых requiredAnswer равен false
   * @type {boolean}
   * @memberof ApplicationDocument
   */
  hasAnswer?: boolean
  /**
   *
   * @type {Date}
   * @memberof ApplicationDocument
   */
  answerDate?: Date
  /**
   *
   * @type {string}
   * @memberof ApplicationDocument
   */
  publishDate?: string
}

/**
 * Check if a given object implements the ApplicationDocument interface.
 */
export function instanceOfApplicationDocument(
  value: object
): value is ApplicationDocument {
  return true
}

export function ApplicationDocumentFromJSON(json: any): ApplicationDocument {
  return ApplicationDocumentFromJSONTyped(json, false)
}

export function ApplicationDocumentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationDocument {
  if (json == null) {
    return json
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    docName: json['docName'] == null ? undefined : json['docName'],
    linkRequired:
      json['linkRequired'] == null ? undefined : json['linkRequired'],
    requiredAnswer:
      json['requiredAnswer'] == null ? undefined : json['requiredAnswer'],
    hasAnswer: json['hasAnswer'] == null ? undefined : json['hasAnswer'],
    answerDate:
      json['answerDate'] == null ? undefined : new Date(json['answerDate']),
    publishDate: json['publishDate'] == null ? undefined : json['publishDate'],
  }
}

export function ApplicationDocumentToJSON(
  value?: ApplicationDocument | null
): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    docName: value['docName'],
    linkRequired: value['linkRequired'],
    requiredAnswer: value['requiredAnswer'],
    hasAnswer: value['hasAnswer'],
    answerDate:
      value['answerDate'] == null
        ? undefined
        : value['answerDate'].toISOString(),
    publishDate: value['publishDate'],
  }
}
